import { useState } from "react";
import { Document, Page } from "react-pdf";
import { FaDownload } from "react-icons/fa";

export default function LocalReactPDFViewer({ fileUrl, title }) {
	const [numPages, setNumPages] = useState(null);
	const [scale, setScale] = useState(0.5);
	const [loading, setLoading] = useState(true);

	const handleDownload = () => {
		const link = document.createElement("a");
		link.href = fileUrl;
		link.download = "1stle document.pdf";
		link.click();
	};

	return (
		<div style={{ position: "relative", height: "100vh", overflow: "hidden", background: "#f0f0f0" }}>
			<div className="flex justify-center gap-4 items-center px-4 py-2 text-white sticky top-0 z-50" style={{ background: "#333" }}>
				<div className="flex items-center gap-2">
					<button onClick={() => setScale((prev) => Math.max(0.5, prev - 0.2))} className=" px-2 py-1 rounded ">
						-
					</button>
					<span className="bg-black px-2 py-1 rounded text-sm">{(scale * 100).toFixed(0)}%</span>
					<button onClick={() => setScale((prev) => Math.min(3.0, prev + 0.2))} className=" px-2 py-1 rounded ">
						+
					</button>
				</div>

				<div className="flex items-center gap-3">
					<button onClick={handleDownload} className="p-2 rounded  flex items-center justify-center">
						<FaDownload className="text-white" />
					</button>
				</div>
			</div>
			<div style={{ overflowY: "auto", height: "calc(100vh - 50px)" }} className="bg-stone-800 flex justify-center ">
				<Document
					key={fileUrl}
					file={fileUrl}
					onLoadSuccess={({ numPages }) => {
						setNumPages(numPages);
						setLoading(false);
					}}
					loading="Loading PDF...">
					{Array.from(new Array(numPages), (_, index) => (
						<Page key={`page_${index + 1}`} pageNumber={index + 1} scale={scale} className="mb-1" />
					))}
				</Document>
			</div>
		</div>
	);
}
